import loginWindowCompleted from "../../../../../../public/images/access-screens/loginWindowCompleted.png";
import { useTranslation } from "react-i18next";

const LoginWindowCompleted = ({
  orgBasedFeatureName = "assessment"
}: {
  orgBasedFeatureName?: string;
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center space-y-5 text-center justify-center w-full py-10">
      <img
        src={loginWindowCompleted}
        alt="loginWindowCompleted"
        className="w-[300px] h-[300px] lg:w-[500px] lg:h-[500px] object-cover"
      />
      <div className="max-w-[800px]">
        <h1 className="text-2xl text-primary font-bold">
          {t("assessment.loginWindow.expiredTitle")}
        </h1>
        <p className="mt-5 text-primary text-base">
          {t("assessment.loginWindow.expiredMessage", {
            featureName: orgBasedFeatureName
          })}
        </p>
      </div>
    </div>
  );
};

export default LoginWindowCompleted;
